import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class ActionSuggestion extends createImmutableObjectClass({
  id: '',
  selected: false,
  name: '',
  shouldSaveAutomatically: true,
  generateAction: () => {
    throw new Error('generateAction must be implemented');
  }
}) {}